import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

const baseUrl = `${environment.apiUrl}/pdf`;

@Injectable({
    providedIn: 'root'
  })
  export class PdfGenerationService {
  
    constructor(
      private http: HttpClient) { }

      postReceiptPdfRequest( invoiceID: number, clientID: number, contactID: string ): Observable<any> {
        var url = `${baseUrl}/receipt-pdf-request?invoiceID=${invoiceID}&clientID=${clientID}&contactID=${contactID}`;
        return this.http.get<any>(`${baseUrl}/receipt-pdf-request?invoiceID=${invoiceID}&clientID=${clientID}&contactID=${contactID}`).pipe();
      }

      validateToken(token: string ): Observable<any>{
        return this.http.get<any>(`${baseUrl}/validate-token?token=${token}`).pipe();
      }
}